import clsx from "clsx";
import { MonitorOff, MonitorPlay, Presentation } from "lucide-react";

import {
  getTabPreviewState,
  isPreviewModeOnGlobally,
  isTabOptedOutOfPreviewMode,
  optTabIntoPreviewMode,
  optTabOutOfPreviewMode,
  type TabPreviewState,
} from "@/preview-mode";

function statusDetail(state: TabPreviewState) {
  if (state === "realData") {
    return isTabOptedOutOfPreviewMode()
      ? "This tab is opted out"
      : "This tab is showing real data";
  }
  if (state === "preview" && !isPreviewModeOnGlobally()) {
    return "Turned off in another tab. Reload to show real data.";
  }
  return null;
}

export const PreviewModeMenuSection = () => {
  const state = getTabPreviewState();
  const on = state !== "off";
  const realData = state === "realData";
  const detail = statusDetail(state);
  const statusColor = !on
    ? "text-textSubtle"
    : realData
      ? "text-status-warning"
      : "text-status-success";
  const statusBackground = !on
    ? undefined
    : realData
      ? "bg-status-warning-tint"
      : "bg-status-success-tint";

  return (
    <div
      role="group"
      aria-labelledby="account-menu-preview-mode"
      className="border-b border-b-gray-200 p-2"
    >
      <div
        id="account-menu-preview-mode"
        className="text-label-xs text-textSubtle flex items-center gap-1 px-2 pt-1 pb-1 uppercase"
      >
        Preview mode
      </div>
      <div
        className={clsx(
          "flex items-start gap-2 rounded-md p-2",
          statusBackground,
        )}
      >
        <span className={clsx("flex-shrink-0", statusColor)}>
          <Presentation size={18} />
        </span>
        <span className="flex flex-col">
          <span
            className={clsx(
              on ? ["font-semibold", statusColor] : "text-textDefault",
            )}
          >
            {on ? "On" : "Off"}
          </span>
          {detail && <span className="text-textSubtle text-xs">{detail}</span>}
        </span>
      </div>
      {on && (
        <button
          onClick={realData ? optTabIntoPreviewMode : optTabOutOfPreviewMode}
          className="flex w-full cursor-pointer items-center gap-2 rounded-md p-2 text-left hover:bg-gray-100 focus:bg-gray-100"
        >
          <span className="flex-shrink-0">
            {realData ? <MonitorPlay size={18} /> : <MonitorOff size={18} />}
          </span>
          <span className="text-textDefault block">
            {realData ? "Use preview in this tab" : "Use real data in this tab"}
          </span>
        </button>
      )}
    </div>
  );
};
